import { isAccountNumberBiller, getBillerLabel } from "../../common";

// Shared between the params-on-load lookup and the manual BillSearchForm
// retry so both paths read/build the same shape instead of duplicating it.

export const getBillSearchParamsFromQuery = (searchParams) => {
  const billerValue = searchParams.get("biller") || "";
  const consumerNumber = searchParams.get("consumer_number");
  const legacyValue =
    searchParams.get("account_number") ||
    searchParams.get("reference_number") ||
    searchParams.get("reference_id");
  const phoneValue = searchParams.get("phone_number") || "";

  return {
    referenceValue: consumerNumber || legacyValue || "",
    phoneValue,
    billerValue,
  };
};

export const hasRequiredBillParams = ({ referenceValue, phoneValue, billerValue } = {}) =>
  Boolean(referenceValue && phoneValue && billerValue);

export const buildBillSearchPayload = ({ referenceValue, phoneValue, billerValue }) => ({
  phone_number: phoneValue,
  biller: getBillerLabel(billerValue),
  consumer_number: referenceValue,
  consumer_number_type: isAccountNumberBiller(billerValue)
    ? "account_number"
    : "reference_number",
});


export const buildBillSearchQueryParams = ({ referenceValue, phoneValue, billerValue }) =>
  new URLSearchParams({
    phone_number: phoneValue,
    biller: billerValue,
    consumer_number: referenceValue,
  });
